module.exports = __webpack_public_path__ + "static/media/24.4c82bbc2.jpg";